import { Component, OnInit } from '@angular/core';
import {
  StepType,
  MembershipOption,
  RegistrationStepService,
  LoggingService,
  ChildRegistrationModel,
  RegistrationStep,
  MembershipOptionsRegistrationViewModel,
} from '@fgb/core';
import { tap } from 'rxjs/operators';

interface OptionInfo {
  DisplayName: string;
  Description: string;
  Image: string;
  ReadMore: boolean;
}

@Component({
  selector: 'fgb-registration-membership-options',
  templateUrl: './registration-membership-options.component.html',
  styleUrls: ['./registration-membership-options.component.scss'],
})
export class RegistrationMembershipOptionsComponent implements OnInit {
  constructor(private registrationStepService: RegistrationStepService, private loggingService: LoggingService) {}
  readonly stepType = StepType.MembershipOption;
  membershipOptions: MembershipOption[];
  children: ChildRegistrationModel[];
  optionInfos: OptionInfo[] = [
    {
      DisplayName: 'Basic Membership - FREE',
      Description:
        '- Membership card and lanyard<br /> - Play games in the Fortress Portal<br />- Exclusive email offers<br /><br /> *Offers subject to change',
      Image: 'assets/images/logo-small.svg',
      ReadMore: false,
    },
    {
      DisplayName: 'King Membership - $20',
      Description:
        '- Membership card and lanyard<br /> - Play games in the Fortress Portal<br />- Exclusive email offers<br /> - 2020 Fortress yearbook<br /><br /> *Offers subject to change',
      Image: 'assets/images/logo-small.svg',
      ReadMore: false,
    },
  ];

  ngOnInit() {
    this.registrationStepService
      .fetchRegistrationStepForCurrentWizard(this.stepType)
      .pipe(
        tap((addChildStepData) => {
          let viewModel = addChildStepData.Data as MembershipOptionsRegistrationViewModel;
          this.children = viewModel.Children;
          this.membershipOptions = viewModel.MembershipOptions;
          this._setMembershipOptions(viewModel.MembershipOptions, addChildStepData);
        })
      )
      .toPromise();
  }

  submitStep() {
    this.registrationStepService.submitRegistrationStepData(this.stepType, this.children).toPromise();
  }

  toggle(option: OptionInfo) {
    option.ReadMore = !option.ReadMore;
  }

  _setMembershipOptions(options: MembershipOption[], existingStepData: RegistrationStep) {
    // Check if the step has been completed already.
    let existingChildren: ChildRegistrationModel[];
    if (existingStepData && existingStepData.Data) {
      this.loggingService.info('Using existing step data', existingStepData);
      existingChildren = existingStepData.Data as ChildRegistrationModel[];
    }

    // Set membership option
    this.children.forEach((child) => {
      let existingChild: ChildRegistrationModel | undefined;
      if (existingChildren && existingChildren.length > 1) {
        existingChild = existingChildren.find((x) => x.Firstname === child.Firstname && x.Lastname === child.Lastname);
      } else {
        existingChild = existingChildren[0];
      }

      if (existingChild && existingChild.MembershipOptionId) {
        // this step has already been completed for this child.
        child.MembershipOptionId = existingChild.MembershipOptionId;
      } else {
        // this step has not yet been completed for this child, take default membership option.
        // If there are paid options take the first as default.
        child.MembershipOptionId = options[0].MembershipOptionId;
      }
    });
  }
}
